import { useEffect } from 'react';
import { useAidiAccess, UseAidiAccessResult } from './useAidiAccess';

interface UseAidiAccessImmediateParams {
  caseId: number | null;
  flagOnly?: boolean;
  aidiStatus?: boolean;
  refreshTTLms?: number;
}

// Minimal per-session cache: caseId -> last auto refresh timestamp (ms)
const lastAutoRefresh: Record<number, number> = {};

export function useAidiAccessImmediate(params: UseAidiAccessImmediateParams): UseAidiAccessResult {
  const { refreshTTLms = 2000, ...rest } = params;
  const result = useAidiAccess(rest);

  useEffect(() => {
    const caseId = params.caseId;
    if (!caseId) return;
    const now = Date.now();
    const last = lastAutoRefresh[caseId];
    if (last && now - last < refreshTTLms) return; // within TTL window
    lastAutoRefresh[caseId] = now; // mark first to avoid race duplicates
    result.refreshAidiProgress?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.caseId, refreshTTLms]);

  return result;
}

export type { UseAidiAccessImmediateParams };
